module.exports = __webpack_public_path__ + "static/media/DinersClub.7fac74d9.svg";